import { httpClient } from '@/api/httpClient';
import { resolveAttachmentFilename, type DownloadedFile } from '@/api/fileDownload';
import {
  mapApiResourceToSessionSummary,
  mapSessionSummaryWritePayload,
  type SessionSummary,
  type SessionSummaryApiResource,
  type SessionSummaryWritePayload,
} from './sessionSummariesApi.types';

const DEFAULT_SUMMARY_FILENAME = 'therapy-summary.pdf';

export async function downloadSessionSummaryPdf(noteId: string): Promise<DownloadedFile> {
  const response = await httpClient.get<Blob>('/session-notes/' + noteId + '/summary/pdf', {
    responseType: 'blob',
  });
  return {
    blob: response.data,
    filename: resolveAttachmentFilename(
      response.headers['content-disposition'],
      DEFAULT_SUMMARY_FILENAME
    ),
  };
}

export async function fetchSessionSummary(noteId: string): Promise<SessionSummary> {
  const response = await httpClient.get<SessionSummaryApiResource>(
    '/session-notes/' + noteId + '/summary'
  );
  return mapApiResourceToSessionSummary(response.data);
}

export async function saveSessionSummary(
  noteId: string,
  payload: SessionSummaryWritePayload
): Promise<SessionSummary> {
  const response = await httpClient.put<SessionSummaryApiResource>(
    '/session-notes/' + noteId + '/summary',
    mapSessionSummaryWritePayload(payload)
  );
  return mapApiResourceToSessionSummary(response.data);
}

export async function approveSessionSummary(noteId: string): Promise<SessionSummary> {
  const response = await httpClient.post<SessionSummaryApiResource>(
    '/session-notes/' + noteId + '/summary/approve'
  );
  return mapApiResourceToSessionSummary(response.data);
}

export async function shareSessionSummary(noteId: string): Promise<SessionSummary> {
  const response = await httpClient.post<SessionSummaryApiResource>(
    '/session-notes/' + noteId + '/summary/share'
  );
  return mapApiResourceToSessionSummary(response.data);
}

export async function unshareSessionSummary(noteId: string): Promise<SessionSummary> {
  const response = await httpClient.post<SessionSummaryApiResource>(
    '/session-notes/' + noteId + '/summary/unshare'
  );
  return mapApiResourceToSessionSummary(response.data);
}
